import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Redirect, RouteComponentProps } from "react-router";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import {
  calculateCapacity,
  displayCost,
  displayLocation,
  EventTypes,
  getInitials,
  getOptionTitle,
  getVenuePrimaryPhotoUrl,
  getVenueStartingCost,
  VenueFeatures,
  VenueMenu,
  VenueOption
} from "sweet-global";
import GuestsIcon from "sweet-web/components/icons/GuestsIcon";
import ImageIcon from "sweet-web/components/icons/ImageIcon";
import LightningIcon from "sweet-web/components/icons/LightningIcon";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import {
  ItemLabel,
  ItemTitle,
  Paragraph
} from "sweet-web/components/universal/Text";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import BookPricing from "./BookPricing";

const VenueFeatureTitle = {};
VenueFeatures.forEach(
  venueFeature => (VenueFeatureTitle[venueFeature.name] = venueFeature.title)
);

const EventTypesTitle = {};
EventTypes.forEach(
  eventType => (EventTypesTitle[eventType.name] = eventType.title)
);

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: auto;
  padding-bottom: 60px;
  /* height: 100%; */
`;

const Book = styled.div`
  width: 360px;
  padding: 20px;
  position: absolute;
  top: 50px;
  right: 0;
  border-radius: 5px;
  /* border: 1px solid ${colors.lightGray} */
  background-color: ${colors.nearWhite};
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  @media screen and (max-width: 1050px) {
    display: none;
  }
`;

const Photos = styled.div`
  height: 500px;
  background-color: ${colors.nearBlack};
  z-index: 9;
  overflow: hidden;
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  @media screen and (max-width: 600px) {
    height: 200px;
  }
`;

const Photo = styled.img`
  object-fit: cover;
  overflow: hidden;
  height: 100%;
  width: 100%;
  z-index: 6;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  &:hover {
    transform: scale(1.05);
  }
`;

const ViewPhotosButton = styled.button`
  position: absolute;
  top: -60px;
  right: 0;
  background-color: ${colors.white};
  color: ${colors.nearBlack};
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  border: none;
  z-index: 7;
  outline: none;
  &:hover {
    transform: scale(1.05);
  }
  @media screen and (max-width: 600px) {
    top: -50px;
    right: 0px;
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  padding-right: 450px;
  background-color: white;
  z-index: 10;
  padding-top: 20px;
  position: relative;
  margin-top: 500px;
  @media screen and (max-width: 1050px) {
    padding: 0;
  }
  @media screen and (max-width: 600px) {
    margin-top: 200px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  @media screen and (max-width: 1050px) {
    margin-right: 0;
  }
`;

const ContentSection = styled.div`
  padding: 30px 0;
  width: 100%;
  border-top: 2px solid ${colors.nearWhite};
  &:first-of-type {
    border-top: none;
  }
  position: relative;
`;

const VenueName = styled.h1`
  color: ${colors.nearBlack};
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 5px;
`;

const VenueLocation = styled.h2`
  color: ${colors.gray};
  font-size: 14px;
  font-weight: 600;
`;

const VenueCapacity = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  color: ${colors.nearBlack};
  font-size: 14px;
  font-weight: 600;
`;

const VenueEventTypes = styled.div`
  color: ${colors.gray};
  font-size: 14px;
  font-weight: 600;
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
`;

const SectionTitle = styled.h2`
  color: ${colors.nearBlack};
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 5px;
`;

const Description = styled.p`
  color: ${colors.nearBlack};
  font-size: 14px;
  font-weight: 500;
  margin-top: 15px;
`;

const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  margin: 10px 0;
`;

const Option = styled.div`
  margin: 20px 0 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`;

const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 20px;
  flex-wrap: wrap;
`;

const OptionDetails = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  flex-wrap: wrap;
`;

const OptionDetail = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-right: 20px;
  margin-top: 10px;
  max-width: 500px;
`;

const OptionImageWrapper = styled.div`
  flex-shrink: 0;
  overflow: hidden;
  text-align: center;
  width: 120px;
  height: 120px;
  transition: all 100ms linear;
  border-radius: 5px;
  background: ${colors.nearWhite};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${colors.gray};
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  &:hover {
    img {
      transform: scale(1.05);
    }
  }
`;

const OptionImage = styled.img`
  object-fit: cover;
  overflow: hidden;
  width: 120px;
  height: 120px;
  border-radius: 5px;
  background: ${colors.lighterGray};
  transition: all 100ms linear;
`;

const Features = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 15px;
`;

const Feature = styled.span`
  padding: 2px 5px;
  border: 1px solid ${colors.lightGray};
  color: ${colors.nearBlack};
  margin-right: 5px;
  margin-bottom: 5px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
`;

const Menus = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px 0 10px 0;
`;

const MobileBookFooter = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 60px;
  align-items: center;
  background-color: ${colors.white};
  border-top: 1px solid ${colors.lightGray};
  z-index: 70;
  margin-left: -60px;
  margin-right: -60px;
  text-decoration: none;
  @media screen and (min-width: 1050px) {
    display: none;
  }
  @media screen and (max-width: 600px) {
    padding: 20px;
    margin-left: -20px;
    margin-right: -20px;
  }
`;

const MobileBookEstimate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const MobileBookEstimateLabel = styled.span`
  font-size: 14px;
  color: ${colors.primary};
  font-weight: 500;
`;

const MobileBookEstimatePrice = styled.span`
  font-size: 17px;
  color: ${colors.primary};
  font-weight: 600;
`;

const MobileBookButton = styled(NavLink)`
  padding: 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: ${colors.primary};
  color: ${colors.white};
  font-size: 17px;
  font-weight: 600;
  text-decoration: none;
  @media screen and (min-width: 1050px) {
    display: none;
  }
`;

type OwnProps = {
  preview?: boolean;
};

type Props = OwnProps & RouteComponentProps & ConnectedProps<typeof connector>;

const ViewVenue: React.FC<Props> = props => {
  const { venueId } = props.match.params as { venueId: string };
  const { venue, uid } = props;

  const capacity = calculateCapacity(venue);

  const primaryPhoto = getVenuePrimaryPhotoUrl(venue);

  if (!venue || (!venue.active && !venue.members[uid])) {
    // if venue is not yet active, you can only view it if you have permission
    return <Redirect to="/" />;
  }

  const foodOptions: VenueOption[] = [];
  const drinkOptions: VenueOption[] = [];

  Object.keys(venue.options).forEach(optionId => {
    const option = venue.options[optionId];
    if (option.type === "FOOD") {
      foodOptions.push({
        ...option,
        id: optionId
      });
    } else if (option.type === "DRINK") {
      drinkOptions.push({
        ...option,
        id: optionId
      });
    }
  });

  const foodMenus: VenueMenu[] = [];
  const drinkMenus: VenueMenu[] = [];

  Object.keys(venue.menus).forEach(menuId => {
    const menu = venue.menus[menuId];
    if (menu.type === "FOOD") {
      foodMenus.push({
        ...menu,
        id: menuId
      });
    } else if (menu.type === "DRINK") {
      drinkMenus.push({
        ...menu,
        id: menuId
      });
    }
  });

  const followLink = (link: string) => {
    const win = window.open(link, "_blank");
    win.focus();
  };

  return (
    <React.Fragment>
      <Wrapper
        id="sweet-view-venue-wrapper"
        style={{ background: colors.white }}
      >
        <Photos
          onClick={() => {
            if (primaryPhoto) {
              props.history.push(`${props.location.pathname}/photos`);
            }
          }}
        >
          <Photo src={primaryPhoto} />
        </Photos>
        <Body>
          {primaryPhoto && (
            <ViewPhotosButton
              onClick={() =>
                props.history.push(`${props.location.pathname}/photos`)
              }
            >
              <ImageIcon
                size={14}
                color={colors.nearBlack}
                style={{ marginRight: 5, marginTop: 4 }}
              />
              View Photos
            </ViewPhotosButton>
          )}
          <Content>
            <ContentSection>
              <VenueName>{venue.name ? venue.name : "New Venue"}</VenueName>
              {venue.location && (
                <VenueLocation>{displayLocation(venue.location)}</VenueLocation>
              )}
              {capacity.min != 0 && (
                <VenueCapacity>
                  <GuestsIcon
                    style={{ marginRight: 5 }}
                    size={14}
                    color={colors.nearBlack}
                  />
                  {capacity.range}
                </VenueCapacity>
              )}
              {venue.eventTypes && (
                <VenueEventTypes>
                  {venue.eventTypes.map((eventType, i) => (
                    <Feature key={`venue-event-type-${i}`}>
                      {EventTypesTitle[eventType]}
                    </Feature>
                  ))}
                </VenueEventTypes>
              )}
              {props.preview && (
                <OutlineButton
                  style={{ position: "absolute", top: 35, right: 0 }}
                  title="Edit"
                  link={true}
                  onClick={() => props.history.push(`/listing/${venueId}`)}
                />
              )}
            </ContentSection>

            {venue.description && (
              <ContentSection>
                <SectionTitle>About Venue</SectionTitle>

                <Description>{venue.description}</Description>
              </ContentSection>
            )}

            {venue.spaces && Object.keys(venue.spaces).length > 0 && (
              <ContentSection>
                <SectionTitle>Space Options</SectionTitle>
                <OptionsWrapper>
                  {Object.keys(venue.spaces).map((spaceId, i) => {
                    const space = venue.spaces[spaceId];
                    const primarySpacePhoto = getVenuePrimaryPhotoUrl(
                      venue,
                      spaceId
                    );

                    return (
                      <Option key={`explore-space-${i}`}>
                        {primarySpacePhoto && (
                          <OptionImageWrapper
                            onClick={() =>
                              props.history.push(
                                props.location.pathname + "/photos"
                              )
                            }
                          >
                            <OptionImage src={primarySpacePhoto} />
                          </OptionImageWrapper>
                        )}
                        {!primarySpacePhoto && (
                          <OptionImageWrapper>
                            {getInitials(space.name)}
                          </OptionImageWrapper>
                        )}
                        <OptionContent>
                          <ItemTitle style={{ margin: 0 }}>
                            {space.name}
                          </ItemTitle>
                          <OptionDetails>
                            {space.description && (
                              <OptionDetail>
                                <ItemLabel
                                  style={{
                                    marginBottom: 0,
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  Description
                                </ItemLabel>
                                <Paragraph>{space.description}</Paragraph>
                              </OptionDetail>
                            )}
                            {space.capacity && (
                              <OptionDetail>
                                <ItemLabel
                                  style={{
                                    marginBottom: 0,
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  Capacity
                                </ItemLabel>
                                <Paragraph>{space.capacity}</Paragraph>
                              </OptionDetail>
                            )}
                            {space.startingCost && (
                              <OptionDetail>
                                <ItemLabel
                                  style={{
                                    marginBottom: 0,
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  Starting Cost
                                </ItemLabel>
                                <Paragraph style={{ whiteSpace: "nowrap" }}>
                                  {displayCost(space.startingCost)}
                                </Paragraph>
                              </OptionDetail>
                            )}
                          </OptionDetails>
                          {space.features && (
                            <Features>
                              {space.features.map((feature, i) => (
                                <Feature key={`space-${spaceId}-feature-${i}`}>
                                  {VenueFeatureTitle[feature]}
                                </Feature>
                              ))}
                            </Features>
                          )}
                        </OptionContent>
                      </Option>
                    );
                  })}
                </OptionsWrapper>
                {props.preview && (
                  <OutlineButton
                    style={{ position: "absolute", top: 25, right: 0 }}
                    title="Edit"
                    link={true}
                    onClick={() =>
                      props.history.push(`/listing/${venueId}/spaces`)
                    }
                  />
                )}
              </ContentSection>
            )}
            {(foodOptions.length > 0 || foodMenus.length > 0) && (
              <ContentSection>
                <SectionTitle>Food Options</SectionTitle>
                {foodOptions.length > 0 && (
                  <OptionsWrapper>
                    {foodOptions.map((option, i) => {
                      const primaryOptionPhoto = getVenuePrimaryPhotoUrl(
                        venue,
                        option.id
                      );

                      return (
                        <Option key={`explore-option-${i}`}>
                          {primaryOptionPhoto && (
                            <OptionImageWrapper
                              onClick={() =>
                                props.history.push(
                                  props.location.pathname + "/photos"
                                )
                              }
                            >
                              <OptionImage src={primaryOptionPhoto} />
                            </OptionImageWrapper>
                          )}
                          {!primaryOptionPhoto && (
                            <OptionImageWrapper>
                              {getInitials(getOptionTitle(option))}
                            </OptionImageWrapper>
                          )}
                          <OptionContent>
                            <ItemTitle>{getOptionTitle(option)}</ItemTitle>
                            <OptionDetails>
                              {option.description && (
                                <OptionDetail>
                                  <ItemLabel
                                    style={{
                                      marginBottom: 0,
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    Description
                                  </ItemLabel>
                                  <Paragraph>{option.description}</Paragraph>
                                </OptionDetail>
                              )}
                              {option.startingCost && (
                                <OptionDetail>
                                  <ItemLabel
                                    style={{
                                      marginBottom: 0,
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    Starting Cost
                                  </ItemLabel>
                                  <Paragraph>
                                    {displayCost(option.startingCost)}
                                  </Paragraph>
                                </OptionDetail>
                              )}
                            </OptionDetails>
                          </OptionContent>
                        </Option>
                      );
                    })}
                  </OptionsWrapper>
                )}
                {props.preview && (
                  <OutlineButton
                    style={{ position: "absolute", top: 25, right: 0 }}
                    title="Edit"
                    link={true}
                    onClick={() =>
                      props.history.push(`/listing/${venueId}/services`)
                    }
                  />
                )}
                {foodMenus.length > 0 && (
                  <Menus>
                    {foodMenus.map((menu, i) => (
                      <OutlineButton
                        key={`view-venue-food-menu-${i}`}
                        title={menu.name}
                        onClick={() => followLink(menu.file.url)}
                        style={{ marginRight: 10, marginBottom: 10 }}
                      />
                    ))}
                  </Menus>
                )}
              </ContentSection>
            )}
            {(drinkOptions.length > 0 || drinkMenus.length > 0) && (
              <ContentSection>
                <SectionTitle>Drink Options</SectionTitle>
                {drinkOptions.length > 0 && (
                  <OptionsWrapper>
                    {drinkOptions.map((option, i) => {
                      const primaryOptionPhoto = getVenuePrimaryPhotoUrl(
                        venue,
                        option.id
                      );

                      return (
                        <Option key={`explore-option-${i}`}>
                          {primaryOptionPhoto && (
                            <OptionImageWrapper
                              onClick={() =>
                                props.history.push(
                                  props.location.pathname + "/photos"
                                )
                              }
                            >
                              <OptionImage src={primaryOptionPhoto} />
                            </OptionImageWrapper>
                          )}
                          {!primaryOptionPhoto && (
                            <OptionImageWrapper>
                              {getInitials(getOptionTitle(option))}
                            </OptionImageWrapper>
                          )}
                          <OptionContent>
                            <ItemTitle>{getOptionTitle(option)}</ItemTitle>
                            <OptionDetails>
                              {option.description && (
                                <OptionDetail>
                                  <ItemLabel
                                    style={{
                                      marginBottom: 0,
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    Description
                                  </ItemLabel>
                                  <Paragraph>{option.description}</Paragraph>
                                </OptionDetail>
                              )}
                              {option.startingCost && (
                                <OptionDetail>
                                  <ItemLabel
                                    style={{
                                      marginBottom: 0,
                                      whiteSpace: "nowrap"
                                    }}
                                  >
                                    Starting Cost
                                  </ItemLabel>
                                  <Paragraph>
                                    {displayCost(option.startingCost)}
                                  </Paragraph>
                                </OptionDetail>
                              )}
                            </OptionDetails>
                          </OptionContent>
                        </Option>
                      );
                    })}
                  </OptionsWrapper>
                )}
                {drinkMenus.length > 0 && (
                  <Menus>
                    {drinkMenus.map((menu, i) => (
                      <OutlineButton
                        key={`view-venue-drink-menu-${i}`}
                        title={menu.name}
                        onClick={() => followLink(menu.file.url)}
                        style={{ marginRight: 10, marginBottom: 10 }}
                      />
                    ))}
                  </Menus>
                )}
                {props.preview && (
                  <OutlineButton
                    style={{ position: "absolute", top: 25, right: 0 }}
                    title="Edit"
                    link={true}
                    onClick={() =>
                      props.history.push(`/listing/${venueId}/services`)
                    }
                  />
                )}
              </ContentSection>
            )}
          </Content>
          <Book>
            <BookPricing venueId={venueId} preview={props.preview} />
          </Book>
        </Body>
      </Wrapper>
      <MobileBookFooter>
        <MobileBookEstimate>
          <MobileBookEstimateLabel>From</MobileBookEstimateLabel>
          <MobileBookEstimatePrice>
            {displayCost(getVenueStartingCost(venue))}
          </MobileBookEstimatePrice>
        </MobileBookEstimate>
        <MobileBookButton to={`/v/${venueId}/book`}>
          <LightningIcon
            size={17}
            color={colors.white}
            style={{ marginTop: 3, marginRight: 5 }}
          />
          Price Estimate
        </MobileBookButton>
      </MobileBookFooter>
    </React.Fragment>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { venueId } = ownProps.match.params as { venueId: string };

  return {
    venue: selectors.getVenue(venueId)(state),
    uid: selectors.uid(state)
  };
};
const connector = connect(mapState);

export default connector(ViewVenue);
